export const intercomConstants = {
    RESET_INTERCOM_IDENTIFICATION: "RESET_INTERCOM_IDENTIFICATION",
    SET_INTERCOM_READY: "SET_INTERCOM_READY",
    SET_PENDING_INTERCOM_OPEN: "SET_PENDING_INTERCOM_OPEN",
    SET_INTERCOM_UNREAD_COUNT: "SET_INTERCOM_UNREAD_COUNT",
}
